import { __assign } from "tslib";
import React, { useCallback } from "react";
import { Image, Platform, TouchableOpacity, View } from "react-native";
import { PnmacHeadline, PnmacHtmlToNative, PnmacSubheading } from "pnmac-universal-components";
import ModalFaqs from "./ModalFaqs";
import { textStyle } from '../../v2/theme';
function Section(_a) {
  var title = _a.title,
    value = _a.value,
    onPress = _a.onPress;
  return /*#__PURE__*/React.createElement(TouchableOpacity, {
    onPress: onPress,
    style: [styles.sectionView, Platform.OS === "web" && {
      margin: 20
    }]
  }, /*#__PURE__*/React.createElement(PnmacHeadline, {
    style: styles.sectionTitle
  }, title), /*#__PURE__*/React.createElement(PnmacHtmlToNative, {
    value: value
  }));
}
function Payoff(_a) {
  var translations = _a.translations,
    showImage = _a.showImage,
    showKnow = _a.showKnow,
    small = _a.small;
  var _b = React.useState(false),
    modalOpen = _b[0],
    setModalOpen = _b[1];
  var _c = React.useState(null),
    faqData = _c[0],
    setFaqData = _c[1];
  var _d = React.useState(null),
    faqDataHTML = _d[0],
    setFaqDataHTML = _d[1];
  var onPress = useCallback(function (data, html) {
    if (data === void 0) {
      data = "";
    }
    if (html === void 0) {
      html = "";
    }
    setModalOpen(true);
    setFaqData(data);
    setFaqDataHTML(html);
  }, []);
  return /*#__PURE__*/React.createElement(View, {
    style: {
      margin: 10
    }
  }, !!showImage && /*#__PURE__*/React.createElement(Image, {
    style: styles.image,
    source: require("../../assets/houses-lined-up.png")
  }), showKnow && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PnmacHeadline, null, translations.WhatYouNeedtoKnow), /*#__PURE__*/React.createElement(PnmacSubheading, {
    style: styles.subHeader
  }, translations.WorkWithEscrow)), /*#__PURE__*/React.createElement(View, {
    style: Platform.OS === "web" && !small && {
      flexDirection: "row",
      marginHorizontal: -20
    }
  }, /*#__PURE__*/React.createElement(Section, {
    title: translations === null || translations === void 0 ? void 0 : translations.Payoff_Before,
    value: translations === null || translations === void 0 ? void 0 : translations.BeforeList,
    onPress: function () {
      return onPress(translations === null || translations === void 0 ? void 0 : translations.Payoff_Before, translations === null || translations === void 0 ? void 0 : translations.BeforeFaq);
    }
  }), /*#__PURE__*/React.createElement(Section, {
    title: translations === null || translations === void 0 ? void 0 : translations.Payoff_During,
    value: translations === null || translations === void 0 ? void 0 : translations.DuringList,
    onPress: function () {
      return onPress(translations === null || translations === void 0 ? void 0 : translations.Payoff_During, translations === null || translations === void 0 ? void 0 : translations.DuringFaq);
    }
  }), /*#__PURE__*/React.createElement(Section, {
    title: translations === null || translations === void 0 ? void 0 : translations.Payoff_After,
    value: translations === null || translations === void 0 ? void 0 : translations.AfterList,
    onPress: function () {
      return onPress(translations === null || translations === void 0 ? void 0 : translations.Payoff_After, translations === null || translations === void 0 ? void 0 : translations.AfterFaq);
    }
  })), /*#__PURE__*/React.createElement(ModalFaqs, {
    value: faqDataHTML,
    translations: translations,
    open: modalOpen,
    closeModal: function () {
      return setModalOpen(false);
    },
    faqData: faqData
  }));
}
var styles = {
  container: {
    margin: 10
  },
  image: {
    width: "100%",
    height: 300,
    borderRadius: 10,
    marginBottom: 20
  },
  subHeader: __assign(__assign({}, textStyle.defaultTextTitle), {
    color: "#707070"
  }),
  sectionTitle: {
    fontSize: 16,
    marginHorizontal: 20
  },
  sectionView: {
    flex: 1,
    marginTop: 20,
    paddingVertical: 10,
    borderRadius: 10,
    backgroundColor: "#fff",
    shadowColor: "rgba(0,0,0, .08)",
    shadowOffset: {
      height: 4,
      width: 2
    },
    shadowOpacity: 1,
    shadowRadius: 12,
    elevation: 4
  }
};
export default Payoff;